import {Checkbox as ChakraCheckbox, CheckboxProps} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';

interface Props extends CheckboxProps {
  variant?: 'square' | 'circle';
}

export const Checkbox: FC<Props> = ({variant = 'square', children, ...restProps}) => {
  return (
    <ChakraCheckbox
      spacing="16px"
      sx={{
        '.chakra-checkbox__control': {
          border: '2px solid',
          borderColor: colors.textGray,
          width: '24px',
          cursor: 'default',
          height: '24px',
          '&[data-checked]': {
            backgroundColor: colors.green,
            borderColor: colors.green,
          },
          '&[data-checked][data-hover]': {
            backgroundColor: colors.green,
            borderColor: colors.green,
          },
          '&[data-focus]': {
            boxShadow: 'none',
          },
          borderRadius: variant === 'circle' ? 'full' : '6px',
        },
      }}
      {...restProps}
    >
      {children}
    </ChakraCheckbox>
  );
};
